import {h} from 'preact'

function Row({children}) {
  return (
    <div className="row">
      {children}
    </div>
  )
}

const Layout = {
  Row
}

export default Layout;
